import { Circle } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function CustomBreadcrumbs() {
  // Route Data
  const location = useLocation();

  // Local State
  const [pathData, setPathData] = useState([]);

  useEffect(() => {
    let arrayPath = location.pathname.split("/").slice(1);
    let newPath = [];
    let newValue = "";
    if (
      location.pathname.includes("edit") ||
      location.pathname.includes("detail") ||
      location.pathname.includes("tambah") 
      
    ) {
      arrayPath.splice(arrayPath.length - 1, arrayPath.length);
    }else if(location.pathname.includes("ubah-password")){
      arrayPath.splice(arrayPath.length - 2, arrayPath.length);
    }
    for (let i = 0; i < arrayPath.length; i++) {
      newValue += `/${arrayPath[i]}`;
      let newItem = {
        value: newValue,
        name: `${arrayPath[i].charAt(0).toUpperCase() + arrayPath[i].slice(1)}`,
      };
      newPath.push(newItem);
    }

    setPathData(newPath);
  }, [location]);

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Link style={{ textDecoration: "none", color: "#0A543B" }} to="/admin">
        Dashboard
      </Link>

      {pathData.length > 0 &&
        pathData.map((item, i) => {
          return (
            <div key={i} style={{display:"flex", alignItems:"center"}}>
              <Circle
                fontSize="16px"
                style={{ color: "#0A543B", margin: "10px" }}
              />
              <Link
                to={item.value}
                style={{ textDecoration: "none", color: "#0A543B" }}
              >
                {item.name.includes("-")
                  ? item.name.replace("-", " ")
                  : item.name}
              </Link>
            </div>
          );
        })}
    </div>
  );
}
